<div class="po-xl-6 po-lg-6 po-md-12 po-sm-12 late-cards">
  <po-widget>
    <span class="po-font-text-bold">Cartões em atraso por operadora</span>
    <div class="icon-loading" *ngIf="loading && !errorApi">
      <app-loading-icon></app-loading-icon>
    </div>
    <div *ngIf="!loading && errorApi">
      <app-error [message]="message"></app-error>
    </div>
    <div *ngIf="!loading && !errorApi">
      <fusioncharts width="100%" height="300" type="bar2d" [dataSource]="dataSource">
      </fusioncharts>
    </div>
  </po-widget>
</div>